module.exports = __webpack_public_path__ + "static/media/drum.6b1894c5.svg";